module.exports = __webpack_public_path__ + "static/img/Tutorial.bfe5613.png";


//////////////////
// WEBPACK FOOTER
// ./static/ios/Tutorial.png
// module id = NcbL
// module chunks = 0